export class BoardApprovalActionsResultDto {
    actionCode: string;
    displayText: string;
    reasonRequiredForAction: boolean;
    displayTextForWarningMessage: string;
    imageIndicator: string;
    allowResponseToOwner: boolean;

    // Transient Property
    icon: string;
    type: string;
}
